import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import ThemeProvider from "@material-ui/styles/ThemeProvider";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import CssBaseline from "@material-ui/core/CssBaseline";
import {LOCAL_STORAGE_VERSION} from "./constant";

const theme = createMuiTheme({
    palette: {
        primary: {
            light: "#55a3b3",
            main: "#2b8ca1",
            dark: "#1e6270"
        },
        text: {
            secondary: "black"
        }
    },
    typography: {
        fontSize: 12
    }
});
if (LOCAL_STORAGE_VERSION !== localStorage.getItem("version")) {
    localStorage.clear();
    localStorage.setItem("version", LOCAL_STORAGE_VERSION);
}
ReactDOM.render(
    <ThemeProvider theme={theme}>
        <CssBaseline/>
        <App/>
    </ThemeProvider>,
    document.getElementById("root"));
